import type { ReactElement } from "react";
import type { ParcelIntelReportData } from "../createPropertyReport";
import type { InspectorPresentation } from "./BaseLayersCard";
import { buildGeneralParcelRows, type GeneralKvRow } from "./generalParcelIntelRows";
import { SidetextRow } from "./SidetextRow";
import { SubsectionHeader } from "./SubsectionHeader";

export interface GeneralLayersCardProps {
  parcelIntel: ParcelIntelReportData | null;
  /** WGS84 site center — always shown in the General card. */
  siteCenter: { lat: number; lon: number };
  presentation?: InspectorPresentation;
}

export function GeneralLayersCard({
  parcelIntel,
  siteCenter,
  presentation = "inspector"
}: GeneralLayersCardProps): ReactElement {
  const drawerRail = presentation === "drawer";

  const coordRows: GeneralKvRow[] = [
    {
      key: "lat",
      label: "Latitude",
      value: siteCenter.lat.toFixed(5),
      mono: true
    },
    {
      key: "lon",
      label: "Longitude",
      value: siteCenter.lon.toFixed(5),
      mono: true
    }
  ];
  const parcelRows =
    parcelIntel != null ? buildGeneralParcelRows(parcelIntel) : [];

  return (
    <div>
      <SubsectionHeader label="Location" first />
      {coordRows.map((r) => (
        <SidetextRow
          key={r.key}
          label={r.label}
          sideText={r.value}
          monoSideText
          drawerRail={drawerRail}
        />
      ))}
      {parcelRows.length > 0 ? (
        <>
          <SubsectionHeader label="Parcel record" />
          {parcelRows.map((r) => (
            <SidetextRow
              key={r.key}
              label={r.label}
              sideText={r.value}
              monoSideText={r.mono === true}
              drawerRail={drawerRail}
            />
          ))}
        </>
      ) : null}
    </div>
  );
}
